module.exports = __webpack_public_path__ + "muli-italic-webfont.61f3daa74b1afccf7690.woff2";


//////////////////
// WEBPACK FOOTER
// /var/jenkins_home/workspace/koraal-mijnmening-backoffice/checkout/src/assets/fonts/muli/muli-italic-webfont.woff2
// module id = ../../../../../src/assets/fonts/muli/muli-italic-webfont.woff2
// module chunks = styles